export const selectCheckboxColors = {
  checked: '#4C5ECF',
  unChecked: '#353b60',
  checkedDisabled: '#4C5ECF',
  unCheckedDisabled: '#353b60',
  hoverColor: '#4C5ECF'
};